import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ isOpen, onClose, orderDetails }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleViewDownloads = () => {
    onClose();
    navigate('/downloads');
  };

  const handleContinueShopping = () => {
    onClose();
    navigate('/e-book-catalog');
  };

  return (
    <>
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-500" />
      <div className="fixed inset-0 z-600 flex items-center justify-center p-4">
        <div className="bg-card rounded-lg shadow-2xl w-full max-w-md">
          <div className="p-6 md:p-8 text-center space-y-4 md:space-y-6">
            <div className="w-16 h-16 md:w-20 md:h-20 mx-auto bg-success/10 rounded-full flex items-center justify-center">
              <Icon name="CheckCircle" size={40} className="text-success" />
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground">
                Purchase Complete!
              </h2>
              <p className="text-sm md:text-base text-muted-foreground">
                Your order has been processed successfully
              </p>
            </div>

            <div className="bg-muted/50 rounded-md p-4 space-y-3 text-left">
              <div className="flex justify-between items-center text-sm">
                <span className="text-muted-foreground">Order Number</span>
                <span className="font-medium text-foreground data-text">
                  {orderDetails?.orderNumber}
                </span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-muted-foreground">Total Paid</span>
                <span className="font-medium text-foreground data-text">
                  ${orderDetails?.total?.toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-muted-foreground">Items</span>
                <span className="font-medium text-foreground">
                  {orderDetails?.itemCount} eBook{orderDetails?.itemCount > 1 ? 's' : ''}
                </span>
              </div>
            </div>

            <div className="space-y-3 pt-4 border-t border-border">
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <Icon name="Mail" size={18} className="flex-shrink-0 mt-0.5 text-primary" />
                <span className="text-left">
                  A confirmation email has been sent to <span className="font-medium text-foreground">{orderDetails?.email}</span>
                </span>
              </div>
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <Icon name="Download" size={18} className="flex-shrink-0 mt-0.5 text-primary" />
                <span className="text-left">
                  Your eBooks are ready for immediate download
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-3 pt-4">
              <Button
                variant="default"
                fullWidth
                iconName="Download"
                iconPosition="left"
                onClick={handleViewDownloads}
              >
                View Downloads
              </Button>
              <Button
                variant="outline"
                fullWidth
                onClick={handleContinueShopping}
              >
                Continue Shopping
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessModal;